module.exports = __webpack_public_path__ + "static/media/dummyjava.b2dea86e.png";